export function compareDates(a: any, b: any) {
	const dataA = new Date(a)
	const dataB = new Date(b)
  
	return (dataA.getTime() - dataB.getTime()) as number
}
